package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.corVinculo
import br.com.htms.inspeccaocampo.ui.kit.TabelaPortal
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.OpcaoResposta
import br.com.htms.inspeccaocampo.ui.kit.LinhaTabela
import br.com.htms.inspeccaocampo.ui.kit.LinhaKpis
import br.com.htms.inspeccaocampo.ui.kit.Kpi
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalho
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalhoOrdenavel
import br.com.htms.inspeccaocampo.ui.kit.Ordenacao
import br.com.htms.inspeccaocampo.ui.kit.Celula
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.CampoBusca
import br.com.htms.inspeccaocampo.ui.kit.PainelFixo
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.Box
import androidx.compose.material3.Icon
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.AccountBox
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.Icons
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.graphics.Color
import br.com.htms.inspeccaocampo.ui.kit.CartaoBranco
import br.com.htms.inspeccaocampo.ui.kit.ChipCor
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardDocumentosCarregando
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.OffsetMapping
import androidx.compose.ui.text.input.TransformedText
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.funcionarios.Cpf
import br.com.htms.inspeccaocampo.data.funcionarios.DocumentoTipo
import br.com.htms.inspeccaocampo.data.funcionarios.Funcionario
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionarioDocumento
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionariosApi
import br.com.htms.inspeccaocampo.data.os.PgrCargoOpcao
import br.com.htms.inspeccaocampo.data.os.PgrCatalog
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.form.AppTab
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.DateInputMask
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.launch

private fun normalizarBusca(s: String): String =
    PgrCatalog.normalizar(s)

/** Máscara só visual (000.000.000-00): o campo guarda dígitos, evitando o cursor pular. */
internal object CpfVisualTransformation : VisualTransformation {
    private val separadores = intArrayOf(3, 6, 9)

    override fun filter(text: AnnotatedString): TransformedText {
        val formatado = Cpf.formatar(text.text)
        val mapping = object : OffsetMapping {
            override fun originalToTransformed(offset: Int): Int =
                offset + separadores.count { it < offset }

            override fun transformedToOriginal(offset: Int): Int {
                var original = offset
                for (p in separadores) if (p + separadores.indexOf(p) < offset) original--
                return original.coerceIn(0, text.length)
            }
        }
        return TransformedText(AnnotatedString(formatado), mapping)
    }
}

/** Campo de CPF (só dígitos + máscara visual). */
@Composable
internal fun CpfTextField(value: String, onValueChange: (String) -> Unit, isError: Boolean) {
    AppOutlinedTextField(
        value = Cpf.digitos(value),
        onValueChange = { onValueChange(Cpf.digitos(it)) },
        label = { Text("CPF") },
        singleLine = true,
        isError = isError,
        supportingText = if (isError) {
            { Text("CPF inválido") }
        } else null,
        visualTransformation = CpfVisualTransformation,
        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
        modifier = Modifier.fillMaxWidth(),
        colors = FormFieldDefaults.textFieldColors()
    )
}

/** Filtra por nome (sem acento), por dígitos do CPF ou pela matrícula. */
internal fun filtrarFuncionarios(lista: List<Funcionario>, consulta: String): List<Funcionario> {
    val q = consulta.trim()
    if (q.isEmpty()) return lista
    val digitos = q.filter { it.isDigit() }
    val termos = normalizarBusca(q).split(' ').filter { it.isNotBlank() }
    return lista.filter { f ->
        val porCpf = digitos.length >= 3 && f.cpf.contains(digitos)
        val porMatricula = f.matricula.isNotBlank() && normalizarBusca(f.matricula) == normalizarBusca(q)
        val nome = normalizarBusca(f.nome)
        porCpf || porMatricula || (termos.isNotEmpty() && termos.all { nome.contains(it) })
    }
}

internal fun cargoDoFuncionario(f: Funcionario): PgrCargoOpcao? =
    PgrCatalog.opcoes.firstOrNull { it.id == f.cargoId }
        ?: PgrCatalog.opcoes.firstOrNull { it.cargo.nome.equals(f.cargoNome, ignoreCase = true) }

/** Campo de busca de cargo no PGR com lista de resultados; mostra o selecionado com "Trocar". */
@Composable
internal fun CargoPgrPicker(
    selecionado: PgrCargoOpcao?,
    onSelecionar: (PgrCargoOpcao?) -> Unit,
    isError: Boolean = false
) {
    var busca by remember(selecionado) { mutableStateOf(selecionado?.cargo?.nome.orEmpty()) }
    if (selecionado != null) {
        Card(
            modifier = Modifier.fillMaxWidth(),
            colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.primaryContainer)
        ) {
            Row(Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text(selecionado.cargo.nome, fontWeight = FontWeight.Bold)
                    Text("SETOR/GHE: ${selecionado.setorGhe}", style = MaterialTheme.typography.bodySmall)
                }
                TextButton(onClick = { onSelecionar(null) }) { Text("Trocar") }
            }
        }
        return
    }
    AppOutlinedTextField(
        value = busca,
        onValueChange = { busca = it },
        label = { Text("Cargo (digite para buscar no PGR)") },
        singleLine = true,
        isError = isError,
        modifier = Modifier.fillMaxWidth(),
        colors = FormFieldDefaults.textFieldColors()
    )
    val resultados = remember(busca) { PgrCatalog.buscar(busca).take(12) }
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)
    ) {
        if (resultados.isEmpty()) {
            Text("Nenhum cargo encontrado no PGR.", modifier = Modifier.padding(12.dp))
        }
        resultados.forEachIndexed { i, op ->
            if (i > 0) HorizontalDivider()
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { onSelecionar(op) }
                    .padding(horizontal = 12.dp, vertical = 8.dp)
            ) {
                Text(op.cargo.nome, fontWeight = FontWeight.SemiBold)
                Text(op.setorGhe, style = MaterialTheme.typography.bodySmall)
            }
        }
    }
}

/** Lista de documentos do funcionário: abrir, anexar (PDF/JPG/PNG) e remover. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun FuncionarioDocumentosPanel(
    controller: AppController,
    funcionario: Funcionario,
    apenasExtras: Boolean = false
) {
    val versao by controller.documentosVersao.collectAsState()
    val abrindoId by controller.abrindoDocumentoId.collectAsState()
    val scope = rememberCoroutineScope()
    var docs by remember(funcionario.id) { mutableStateOf<List<FuncionarioDocumento>>(emptyList()) }
    var carregando by remember(funcionario.id) { mutableStateOf(true) }
    var erro by remember(funcionario.id) { mutableStateOf<String?>(null) }
    var anexando by remember { mutableStateOf(false) }
    var tipoAnexo by remember { mutableStateOf("ASO") }
    var tituloAnexo by remember { mutableStateOf("") }
    var confirmarRemocao by remember { mutableStateOf<FuncionarioDocumento?>(null) }

    LaunchedEffect(funcionario.id, versao) {
        carregando = true
        FuncionariosApi.documentos(funcionario.id)
            .onSuccess { docs = if (apenasExtras) it.filter { d -> d.tipo == "OUTRO" } else it; erro = null }
            .onFailure { erro = it.message ?: "Falha ao carregar documentos" }
        carregando = false
    }

    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(
                "Documentos extras de ${funcionario.nome} (${docs.size})",
                fontWeight = FontWeight.Bold,
                style = MaterialTheme.typography.titleSmall,
                color = PortalCores.Navy
            )
            when {
                carregando -> CircularProgressIndicator(modifier = Modifier.size(22.dp), strokeWidth = 2.dp)
                erro != null -> Text(erro.orEmpty(), color = MaterialTheme.colorScheme.error)
                docs.isEmpty() -> Text("Nenhum documento ainda.", style = MaterialTheme.typography.bodySmall)
            }
            docs.forEach { d ->
                HorizontalDivider()
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.weight(1f)) {
                        Text(d.titulo.ifBlank { d.fileName }, fontWeight = FontWeight.SemiBold)
                        Text(d.fileName, style = MaterialTheme.typography.bodySmall)
                    }
                    TextButton(
                        onClick = { controller.abrirDocumentoFuncionario(d) },
                        enabled = abrindoId == null
                    ) { Text(if (abrindoId == d.id) "Abrindo..." else "Visualizar") }
                    TextButton(onClick = {
                        scope.launch {
                            FuncionariosApi.baixar(d.id).onSuccess { bytes ->
                                val path = PlatformFiles.join(PlatformFiles.cacheDir(), d.fileName.ifBlank { "documento" })
                                PlatformFiles.writeBytes(path, bytes)
                                PlatformFiles.shareFile(path, d.contentType.ifBlank { "application/octet-stream" }, d.fileName)
                            }.onFailure { erro = it.message ?: "Falha ao baixar" }
                        }
                    }) { Text("Baixar") }
                    TextButton(onClick = { confirmarRemocao = d }) { Text("Remover") }
                }
            }
            val rem = confirmarRemocao
            if (rem != null) {
                Text("Remover \"${rem.titulo}\" do cadastro?", color = MaterialTheme.colorScheme.error)
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    PortalButton(onClick = {
                        confirmarRemocao = null
                        scope.launch {
                            FuncionariosApi.remover(rem.id)
                                .onSuccess { controller.notificarDocumentosAlterados() }
                                .onFailure { erro = it.message }
                        }
                    }) { Text("Remover") }
                    PortalOutlinedButton(onClick = { confirmarRemocao = null }) { Text("Cancelar") }
                }
            }
            HorizontalDivider()
            Text("Documentos extras", fontWeight = FontWeight.SemiBold)
            Text("Sem tipo. O nome exibido é o do arquivo.", style = MaterialTheme.typography.bodySmall)
            AppOutlinedTextField(
                value = tituloAnexo,
                onValueChange = { tituloAnexo = it },
                label = { Text("Nome (opcional; se vazio, usa o nome do arquivo)") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            PortalOutlinedButton(
                enabled = !anexando,
                onClick = {
                    scope.launch {
                        val arquivo = PlatformServices.pickDocument() ?: return@launch
                        anexando = true
                        val titulo = tituloAnexo.trim().ifBlank { arquivo.name }
                        FuncionariosApi.enviarDocumento(
                            funcionarioId = funcionario.id,
                            bytes = arquivo.bytes,
                            tipo = "OUTRO",
                            titulo = titulo,
                            fileName = arquivo.name,
                            emitido = false
                        ).onSuccess {
                            tituloAnexo = ""
                            erro = null
                            controller.notificarDocumentosAlterados()
                        }.onFailure { erro = it.message ?: "Falha ao anexar" }
                        anexando = false
                    }
                }
            ) { Text(if (anexando) "Enviando..." else "Adicionar documento extra") }
        }
    }
}

/** Dados do cadastro (os mesmos da matriz de colaboradores). */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun DadosFuncionario(f: Funcionario) {
    FlowRow(horizontalArrangement = Arrangement.spacedBy(22.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        listOf(
            "Matrícula (MTR)" to f.matricula,
            "Função (cargo)" to f.cargoNome,
            "Situação" to f.situacao,
            "Admissão" to f.admissao,
            "Nascimento" to f.nascimento,
            "RG" to f.rg,
            "CPF" to f.cpfFormatado
        ).forEach { (rotulo, valor) ->
            Column {
                Text(rotulo, style = MaterialTheme.typography.labelSmall, color = PortalCores.CinzaTexto)
                Text(valor.ifBlank { "—" }, color = PortalCores.Texto)
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun SharedFuncionariosScreen(controller: AppController) {
    val versao by controller.documentosVersao.collectAsState()
    val scope = rememberCoroutineScope()
    var lista by remember { mutableStateOf<List<Funcionario>>(emptyList()) }
    var carregando by remember { mutableStateOf(true) }
    var erro by remember { mutableStateOf<String?>(null) }
    var busca by remember { mutableStateOf("") }
    var filtroVinculo by remember { mutableStateOf("") }
    var filtroSituacao by remember { mutableStateOf("") }
    var ordemCol by remember { mutableStateOf("NOME") }
    var ordemAsc by remember { mutableStateOf(true) }
    var selecionadoId by remember { mutableStateOf<String?>(null) }
    var editando by remember { mutableStateOf(false) }
    var editandoId by remember { mutableStateOf<String?>(null) }
    var aba by remember { mutableStateOf("CADASTRO") }

    var nome by remember { mutableStateOf("") }
    var cpf by remember { mutableStateOf("") }
    var admissao by remember { mutableStateOf("") }
    var matricula by remember { mutableStateOf("") }
    var cargo by remember { mutableStateOf<PgrCargoOpcao?>(null) }
    var vinculo by remember { mutableStateOf("CLT") }
    var situacao by remember { mutableStateOf("ATIVO") }
    var nascimento by remember { mutableStateOf("") }
    var rg by remember { mutableStateOf("") }
    var salvando by remember { mutableStateOf(false) }
    var tentouSalvar by remember { mutableStateOf(false) }

    LaunchedEffect(versao) {
        carregando = true
        FuncionariosApi.listar()
            .onSuccess { lista = it; erro = null }
            .onFailure { erro = it.message ?: "Falha ao carregar funcionários" }
        carregando = false
    }

    fun abrirEdicao(f: Funcionario?) {
        aba = "CADASTRO"
        editando = true
        editandoId = f?.id
        tentouSalvar = false
        nome = f?.nome.orEmpty()
        cpf = f?.cpf.orEmpty()
        admissao = f?.admissao.orEmpty()
        matricula = f?.matricula.orEmpty()
        cargo = f?.let { cargoDoFuncionario(it) }
        vinculo = f?.vinculo?.uppercase()?.ifBlank { null } ?: "CLT"
        situacao = f?.situacao?.uppercase()?.ifBlank { null } ?: "ATIVO"
        nascimento = f?.nascimento.orEmpty()
        rg = f?.rg.orEmpty()
    }

    val selecionado = lista.firstOrNull { it.id == selecionadoId }
    val filtrados = remember(lista, busca, filtroVinculo, filtroSituacao, ordemCol, ordemAsc) {
        val base = filtrarFuncionarios(lista, busca).filter { f ->
            (filtroVinculo.isEmpty() || f.vinculo.equals(filtroVinculo, ignoreCase = true)) &&
                (filtroSituacao.isEmpty() || situacaoChave(f.situacao) == filtroSituacao)
        }
        val cmp: Comparator<Funcionario>? = when (ordemCol) {
            "MTR" -> Ordenacao.por(ordemAsc) { it.matricula }
            "NOME" -> Ordenacao.por(ordemAsc) { it.nome }
            "VINCULO" -> Ordenacao.por(ordemAsc) { it.vinculo }
            "FUNCAO" -> Ordenacao.por(ordemAsc) { it.cargoNome }
            "SITUACAO" -> Ordenacao.por(ordemAsc) { it.situacao }
            "ADMISSAO" -> Ordenacao.por(ordemAsc) { dataOrdenavel(it.admissao) }
            "CPF" -> Ordenacao.por(ordemAsc) { it.cpf }
            "DOCS" -> Ordenacao.porNumero(ordemAsc) { it.totalDocumentos.toDouble() }
            else -> null
        }
        if (cmp == null) base else base.sortedWith(cmp.then(Ordenacao.por(true) { it.nome }))
    }
    val situacoesFiltro = remember(lista) {
        lista.groupingBy { situacaoChave(it.situacao) }.eachCount().entries
            .sortedWith(compareBy({ ordemSituacao(it.key) }, { it.key }))
            .map { it.key to it.value }
    }
    fun ordenar(col: String) {
        if (ordemCol == col) ordemAsc = !ordemAsc else { ordemCol = col; ordemAsc = true }
    }
    fun cres(col: String): Boolean? = if (ordemCol == col) ordemAsc else null
    val subAbaPedido by controller.funcionariosSubAba.collectAsState()
    LaunchedEffect(subAbaPedido) {
        if (aba != subAbaPedido) {
            aba = subAbaPedido
            editando = false
        }
    }
    val selecionadoMenu = when (aba) {
        "DASHBOARD" -> DocumentosMenu.DASHBOARD
        "IMPORTAR" -> DocumentosMenu.IMPORTAR
        else -> DocumentosMenu.FUNCIONARIOS
    }
    val tituloModulo = when (aba) {
        "DASHBOARD" -> "Dashboard de documentos"
        "IMPORTAR" -> "Importar planilha"
        else -> "Cadastro de funcionários"
    }

    DocumentosModulo(
        controller = controller,
        tab = AppTab.FUNCIONARIOS,
        titulo = tituloModulo,
        selecionado = selecionadoMenu,
        extraCabecalho = {
            BotaoPlanilha(controller, br.com.htms.inspeccaocampo.export.PlanilhaModulo.FUNCIONARIOS)
            Spacer(Modifier.width(8.dp))
            PortalButton(
                onClick = { selecionadoId = null; abrirEdicao(null) },
                colors = ButtonDefaults.buttonColors(containerColor = PortalCores.Marca)
            ) {
                Icon(Icons.Filled.Add, contentDescription = null, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(6.dp))
                Text("Novo funcionário")
            }
        }
    ) { largo ->
        if (aba == "DASHBOARD") {
            DashboardDocumentosCarregando()
            return@DocumentosModulo
        }
        if (aba == "IMPORTAR") {
            ImportarFuncionariosPanel(controller, lista, onFechar = { controller.abrirFuncionarios("CADASTRO") })
            return@DocumentosModulo
        }

        if (editando) {
            val nomeOk = nome.trim().length >= 3
            val cpfOk = Cpf.valido(cpf)
            val admissaoOk = admissao.isBlank() || DateInputMask.isCompleteValid(admissao, DateFieldKind.DATE)
            val nascimentoOk = nascimento.isBlank() || DateInputMask.isCompleteValid(nascimento, DateFieldKind.DATE)
            val situacoes = (listOf("ATIVO", "AFASTADO", "AFASTADO (MATERNIDADE)", "DESATIVADO") + situacao)
                .filter { it.isNotBlank() }.distinct().map { it to it }
            CartaoSecao(if (editandoId != null) "Editar funcionário" else "Novo funcionário") {
                Par(
                    largo,
                    { m ->
                        AppOutlinedTextField(
                            value = nome,
                            onValueChange = { nome = it },
                            label = { Text("Nome completo") },
                            singleLine = true,
                            isError = tentouSalvar && !nomeOk,
                            modifier = m,
                            colors = FormFieldDefaults.textFieldColors()
                        )
                    },
                    { m -> Column(m) { CpfTextField(value = cpf, onValueChange = { cpf = it }, isError = tentouSalvar && !cpfOk) } }
                )
                Par(
                    largo,
                    { m ->
                        AppOutlinedTextField(
                            value = matricula,
                            onValueChange = { matricula = it.take(40) },
                            label = { Text("Matrícula (MTR)") },
                            singleLine = true,
                            modifier = m,
                            colors = FormFieldDefaults.textFieldColors()
                        )
                    },
                    { m ->
                        Column(m) {
                            AppDateTextField(
                                value = admissao,
                                onValueChange = { admissao = it },
                                label = "Data de admissão",
                                isError = tentouSalvar && !admissaoOk
                            )
                        }
                    }
                )
                Par(
                    largo,
                    { m ->
                        Column(m) {
                            AppDateTextField(
                                value = nascimento,
                                onValueChange = { nascimento = it },
                                label = "Data de nascimento",
                                isError = tentouSalvar && !nascimentoOk
                            )
                        }
                    },
                    { m ->
                        AppOutlinedTextField(
                            value = rg,
                            onValueChange = { rg = it.take(30) },
                            label = { Text("RG") },
                            singleLine = true,
                            modifier = m,
                            colors = FormFieldDefaults.textFieldColors()
                        )
                    }
                )
                Par(
                    largo,
                    { m -> Seletor("Vínculo", listOf("CLT" to "CLT", "PJ" to "PJ"), vinculo, { vinculo = it }, m) },
                    { m -> Seletor("Situação", situacoes, situacao, { situacao = it }, m) }
                )
                CargoPgrPicker(selecionado = cargo, onSelecionar = { cargo = it })
                erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    PortalButton(
                        enabled = !salvando,
                        onClick = {
                            tentouSalvar = true
                            if (!nomeOk || !cpfOk || !admissaoOk || !nascimentoOk) return@PortalButton
                            salvando = true
                            scope.launch {
                                FuncionariosApi.salvar(
                                    nome = nome.trim(),
                                    cpf = cpf,
                                    admissao = admissao,
                                    cargoId = cargo?.id.orEmpty(),
                                    cargoNome = cargo?.cargo?.nome.orEmpty(),
                                    setorGhe = cargo?.setorGhe.orEmpty(),
                                    matricula = matricula,
                                    id = editandoId,
                                    vinculo = vinculo,
                                    situacao = situacao,
                                    nascimento = nascimento,
                                    rg = rg
                                ).onSuccess { f ->
                                    selecionadoId = f.id
                                    editando = false
                                    erro = null
                                    controller.notificarDocumentosAlterados()
                                }.onFailure { erro = it.message ?: "Falha ao salvar" }
                                salvando = false
                            }
                        }
                    ) { Text(if (salvando) "Salvando..." else "Salvar") }
                    PortalOutlinedButton(onClick = { editando = false }) { Text("Cancelar") }
                }
            }
        }

        if (selecionado != null && !editando) {
            CartaoSecao(
                titulo = selecionado.nome,
                subtitulo = "Setor/GHE (PGR): ${selecionado.setorGhe.ifBlank { "—" }}",
                acoes = {
                    if (selecionado.vinculo.isNotBlank()) ChipCor(selecionado.vinculo, corVinculo(selecionado.vinculo))
                    TextButton(onClick = { selecionadoId = null }) { Text("Fechar") }
                }
            ) {
                DadosFuncionario(selecionado)
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    PortalButton(onClick = { controller.emitirOrdemServicoPara(selecionado) }) { Text("Emitir OS") }
                    PortalButton(onClick = { controller.emitirFichaEpiPara(selecionado) }) { Text("Ficha de EPI") }
                    PortalButton(onClick = { controller.emitirCertificadoPara(selecionado) }) { Text("Certificado") }
                    PortalOutlinedButton(onClick = { abrirEdicao(selecionado) }) { Text("Editar") }
                }
            }
            FuncionarioDocumentosPanel(controller, selecionado)
        }

        LinhaKpis(largo) { m ->
            Kpi("Funcionários", lista.size.toString(), Icons.Filled.Person, m, onClick = { filtroVinculo = ""; filtroSituacao = "" })
            Kpi(
                "Ativos",
                lista.count { it.situacao.uppercase().startsWith("ATIVO") }.toString(),
                Icons.Filled.Check,
                m,
                cor = PortalCores.Verde,
                onClick = { filtroSituacao = "ATIVO" }
            )
            Kpi("CLT", lista.count { it.vinculo.equals("CLT", true) }.toString(), Icons.Filled.AccountBox, m, onClick = { filtroVinculo = "CLT" })
            Kpi("PJ", lista.count { it.vinculo.equals("PJ", true) }.toString(), Icons.Filled.AccountBox, m, cor = corVinculo("PJ"), onClick = { filtroVinculo = "PJ" })
        }

        CartaoSecao(
            titulo = "Funcionários",
            subtitulo = "Selecione para ver os dados, emitir documentos ou anexar arquivos. ${filtrados.size} de ${lista.size}."
        ) {
            val filtrosFun: @Composable ColumnScope.() -> Unit = {
            CampoBusca(busca, { busca = it }, "Buscar por nome, CPF ou matrícula", Modifier.fillMaxWidth())
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                listOf("" to "Todos", "CLT" to "CLT", "PJ" to "PJ").forEach { (v, r) ->
                    OpcaoResposta(r, filtroVinculo == v, PortalCores.AzulIcone, { filtroVinculo = v })
                }
            }
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                OpcaoResposta("Todas as situações", filtroSituacao.isEmpty(), PortalCores.AzulIcone, { filtroSituacao = "" })
                situacoesFiltro.forEach { (s, n) ->
                    OpcaoResposta(
                        "${s.lowercase().replaceFirstChar { it.uppercase() }} ($n)",
                        filtroSituacao == s,
                        if (s == SEM_SITUACAO) PortalCores.CinzaTexto else corSituacao(s),
                        { filtroSituacao = if (filtroSituacao == s) "" else s }
                    )
                }
            }
            if (!largo) {
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                    Seletor(
                        "Ordenar por",
                        listOf(
                            "MTR" to "MTR", "NOME" to "Nome", "VINCULO" to "Vínculo", "FUNCAO" to "Função",
                            "SITUACAO" to "Situação", "ADMISSAO" to "Admissão", "CPF" to "CPF", "DOCS" to "Docs"
                        ),
                        ordemCol,
                        { ordemCol = it },
                        Modifier.weight(1f)
                    )
                    PortalOutlinedButton(onClick = { ordemAsc = !ordemAsc }) {
                        Text(if (ordemAsc) "Crescente" else "Decrescente")
                    }
                }
            }
            }
            when {
                carregando && lista.isEmpty() -> CircularProgressIndicator(modifier = Modifier.size(24.dp), strokeWidth = 2.dp)
                erro != null && !editando -> Text(erro.orEmpty(), color = MaterialTheme.colorScheme.error)
                filtrados.isEmpty() -> Text(
                    if (lista.isEmpty()) "Nenhum funcionário cadastrado ainda." else "Nenhum funcionário encontrado.",
                    color = PortalCores.CinzaTexto
                )
            }
            val visiveis = filtrados.take(300)
            if (visiveis.isNotEmpty()) {
                if (largo) {
                    TabelaPortal(
                        antes = filtrosFun,
                        fixar = true,
                        cabecalho = {
                            CelulaCabecalhoOrdenavel("MTR", 0.6f, cres("MTR")) { ordenar("MTR") }
                            CelulaCabecalhoOrdenavel("Nome", 2.6f, cres("NOME")) { ordenar("NOME") }
                            CelulaCabecalhoOrdenavel("Vínculo", 0.8f, cres("VINCULO")) { ordenar("VINCULO") }
                            CelulaCabecalhoOrdenavel("Função", 2f, cres("FUNCAO")) { ordenar("FUNCAO") }
                            CelulaCabecalhoOrdenavel("Situação", 1.1f, cres("SITUACAO")) { ordenar("SITUACAO") }
                            CelulaCabecalhoOrdenavel("Admissão", 1f, cres("ADMISSAO")) { ordenar("ADMISSAO") }
                            CelulaCabecalhoOrdenavel("CPF", 1.3f, cres("CPF")) { ordenar("CPF") }
                            CelulaCabecalhoOrdenavel("Docs", 0.5f, cres("DOCS")) { ordenar("DOCS") }
                        }
                    ) {
                        visiveis.forEach { f ->
                            LinhaTabela(selecionada = f.id == selecionadoId, onClick = { selecionadoId = f.id; editando = false }) {
                                Celula(f.matricula.ifBlank { "—" }, 0.6f)
                                Celula(f.nome, 2.6f, negrito = true, cor = PortalCores.Navy)
                                Box(Modifier.weight(0.8f)) {
                                    if (f.vinculo.isNotBlank()) ChipCor(f.vinculo, corVinculo(f.vinculo))
                                }
                                Celula(f.cargoNome.ifBlank { "—" }, 2f)
                                Box(Modifier.weight(1.1f)) {
                                    if (f.situacao.isNotBlank()) ChipCor(f.situacao, corSituacao(f.situacao))
                                }
                                Celula(f.admissao.ifBlank { "—" }, 1f)
                                Celula(f.cpfFormatado.ifBlank { "—" }, 1.3f)
                                Celula(f.totalDocumentos.toString(), 0.5f)
                            }
                        }
                    }
                } else {
                    PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { filtrosFun() } }
                    visiveis.forEach { f -> CartaoFuncionario(f, f.id == selecionadoId) { selecionadoId = f.id; editando = false } }
                }
                if (filtrados.size > visiveis.size) {
                    Text("Mostrando ${visiveis.size} de ${filtrados.size}. Refine a busca.", color = PortalCores.CinzaTexto)
                }
            } else {
                PainelFixo { Column(verticalArrangement = Arrangement.spacedBy(12.dp)) { filtrosFun() } }
            }
        }
    }
}

@Composable
private fun CartaoFuncionario(f: Funcionario, sel: Boolean, onClick: () -> Unit) {
    Column(
        Modifier
            .fillMaxWidth()
            .background(if (sel) PortalCores.AzulClaro else PortalCores.Cartao, RoundedCornerShape(12.dp))
            .border(1.dp, if (sel) PortalCores.AzulIcone else PortalCores.Borda, RoundedCornerShape(12.dp))
            .clickable(onClick = onClick)
            .padding(horizontal = 14.dp, vertical = 10.dp),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
            Text(f.nome, Modifier.weight(1f), fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
            if (f.vinculo.isNotBlank()) ChipCor(f.vinculo, corVinculo(f.vinculo))
            if (f.situacao.isNotBlank()) ChipCor(f.situacao, corSituacao(f.situacao))
        }
        Text(
            listOf(
                f.matricula.takeIf { it.isNotBlank() }?.let { "MTR $it" },
                f.cargoNome.takeIf { it.isNotBlank() },
                f.cpf.takeIf { it.isNotBlank() }?.let { "CPF ${f.cpfFormatado}" },
                f.admissao.takeIf { it.isNotBlank() }?.let { "Adm. $it" },
                "${f.totalDocumentos} documento(s)"
            ).filterNotNull().joinToString(" • "),
            style = MaterialTheme.typography.bodySmall,
            color = PortalCores.CinzaTexto
        )
    }
}

private const val SEM_SITUACAO = "SEM SITUAÇÃO"

private fun situacaoChave(s: String): String = s.trim().uppercase().ifBlank { SEM_SITUACAO }

private fun ordemSituacao(s: String): Int = when {
    s.startsWith("ATIVO") -> 0
    s.startsWith("AFASTADO") -> 1
    s == SEM_SITUACAO -> 3
    else -> 2
}

/** dd/mm/aaaa -> aaaa/mm/dd para ordenar como data. */
private fun dataOrdenavel(s: String): String {
    val p = s.trim().split('/')
    return if (p.size == 3) "${p[2]}/${p[1]}/${p[0]}" else s
}

private fun corSituacao(s: String): Color = when {
    s.uppercase().startsWith("ATIVO") -> PortalCores.Verde
    s.uppercase().startsWith("AFASTADO") -> PortalCores.Laranja
    else -> PortalCores.CinzaClaro
}